import { Component, computed, input, OnInit, output, signal } from '@angular/core';
import {
  AccordionIconStatus,
  AccordionIconType,
  AccordionItem,
} from '../../interfaces/payment-accordion.types';

@Component({
  selector: 'app-payment-accordion',
  standalone: true,
  imports: [],
  templateUrl: './payment-accordion.component.html',
  styleUrl: './payment-accordion.component.scss',
})
export class PaymentAccordionComponent implements OnInit {
  /* ─── Inputs signal-based (Angular 19) ─── */
  title = input<string>('Información de pago');
  description = input<string>('Pago aprobado · $1.500.000');
  iconType = input<AccordionIconType>('check');
  iconStatus = input<AccordionIconStatus>('success');
  iconSize = input<number>(22);
  items = input<AccordionItem[]>([]);
  initialOpen = input<boolean>(false);
  /** ID único: se usa para aria-controls / aria-labelledby */
  accId = input<string>(crypto.randomUUID().slice(0, 8));

  /* ─── Output ─── */
  openedChange = output<boolean>();

  /* ─── Estado interno ─── */
  isOpen = signal<boolean>(false);

  /* ─── Computed: IDs para aria (Bootstrap pattern) ─── */
  headingId = computed(() => `heading-${this.accId()}`);
  collapseId = computed(() => `collapse-${this.accId()}`);

  ngOnInit(): void {
    this.isOpen.set(this.initialOpen());
  }

  toggle(): void {
    this.isOpen.update((v) => !v);
    this.openedChange.emit(this.isOpen());
  }

  open(): void {
    this.isOpen.set(true);
    this.openedChange.emit(true);
  }
  close(): void {
    this.isOpen.set(false);
    this.openedChange.emit(false);
  }
}
